export const CREATE_GUEST_CONTACT = 'CREATE_GUEST_CONTACT'
export const CREATE_GUEST_CONTACT_SUCCESS = 'CREATE_GUEST_CONTACT_SUCCESS'
export const CREATE_GUEST_CONTACT_FAILED = 'CREATE_GUEST_CONTACT_FAILED'

export const SEARCH_GUEST_CONTACT_START = 'SEARCH_GUEST_CONTACT_START'
export const SEARCH_GUEST_CONTACT_SUCCESS = 'SEARCH_GUEST_CONTACT_SUCCESS'
export const SEARCH_GUEST_CONTACT_FAILED = 'SEARCH_GUEST_CONTACT_FAILED'

export const DELETE_GUEST_START = 'DELETE_GUEST_START'
export const DELETE_GUEST_SUCCESS = 'DELETE_GUEST_SUCCESS'
export const DELETE_GUEST_FAILED = 'DELETE_GUEST_FAILED'

export const GET_GUEST_CONTACT_DETAILS_START = 'GET_GUEST_CONTACT_DETAILS_START'
export const GET_GUEST_CONTACT_DETAILS_SUCCESS =
  'GET_GUEST_CONTACT_DETAILS_SUCCESS'
export const GET_GUEST_CONTACT_DETAILS_FAILED =
  'GET_GUEST_CONTACT_DETAILS_FAILED'

export const ADD_NOTE_GUEST_CONTACT_START = 'ADD_NOTE_GUEST_CONTACT_START'
export const ADD_NOTE_GUEST_CONTACT_SUCCESS = 'ADD_NOTE_GUEST_CONTACT_SUCCESS'
export const ADD_NOTE_GUEST_CONTACT_FAILED = 'ADD_NOTE_GUEST_CONTACT_FAILED'

export const CREATE_ACCOUNT_GUEST_CONTACT_START =
  'CREATE_ACCOUNT_GUEST_CONTACT_START'
export const CREATE_ACCOUNT_GUEST_CONTACT_SUCCESS =
  'CREATE_ACCOUNT_GUEST_CONTACT_SUCCESS'
export const CREATE_ACCOUNT_GUEST_CONTACT_FAILED =
  'CREATE_ACCOUNT_GUEST_CONTACT_FAILED'

export const RESET_GUEST_CONTACT_DETAIL_STATE =
  'RESET_GUEST_CONTACT_DETAIL_STATE'

/**
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 * @returns {object}
 */
export function createGuestContact(payload, onSuccess, onError) {
  return {
    type: CREATE_GUEST_CONTACT,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * @param {*} payload
 * @returns {object}
 */
export function createGuestContactSuccess(payload) {
  return {
    type: CREATE_GUEST_CONTACT_SUCCESS,
    payload: payload,
  }
}

/**
 * @returns {object}
 */
export function createGuestContactFailed() {
  return {
    type: CREATE_GUEST_CONTACT_FAILED,
  }
}

/**
 * Search guest contact
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 * @returns {object}
 */
export function searchGuestContact(payload, onSuccess, onError) {
  return {
    type: SEARCH_GUEST_CONTACT_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * Search guest contact success action
 * @param {*} payload
 * @returns {object}
 */
export function searchGuestContactSuccess(payload) {
  return {
    type: SEARCH_GUEST_CONTACT_SUCCESS,
    payload: payload,
  }
}

/**
 * Search guest contact failed action
 * @returns {object}
 */
export function searchGuestContactFailed() {
  return {
    type: SEARCH_GUEST_CONTACT_FAILED,
  }
}

export function getGuestContactDetailsById(GuestContactId, onSuccess, onError) {
  return {
    type: GET_GUEST_CONTACT_DETAILS_START,
    payload: GuestContactId,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * Get GuestContact details by id success action
 * @param {*} payload
 * @returns {object}
 */
export function getGuestContactDetailsByIdSuccess(payload) {
  return {
    type: GET_GUEST_CONTACT_DETAILS_SUCCESS,
    payload: payload,
  }
}

/**
 * Get GuestContact details by id failed action
 * @returns {object}
 */
export function getGuestContactDetailsByIdFailed() {
  return {
    type: GET_GUEST_CONTACT_DETAILS_FAILED,
  }
}

export function resetGuestContactDetailState() {
  return {
    type: RESET_GUEST_CONTACT_DETAIL_STATE,
  }
}

export function addNoteGuestContact(payload, onSuccess, onError) {
  return {
    type: ADD_NOTE_GUEST_CONTACT_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * @param {*} payload
 * @returns {object}
 */
export function addNoteGuestContactSuccess(payload) {
  return {
    type: ADD_NOTE_GUEST_CONTACT_SUCCESS,
    payload: payload,
  }
}

/**
 * @returns {object}
 */
export function addNoteGuestContactFailed() {
  return {
    type: ADD_NOTE_GUEST_CONTACT_FAILED,
  }
}

export function createAccountGuestContact(payload, onSuccess, onError) {
  return {
    type: CREATE_ACCOUNT_GUEST_CONTACT_START,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  }
}

/**
 * @param {*} payload
 * @returns {object}
 */
export function createAccountGuestContactSuccess(payload) {
  return {
    type: CREATE_ACCOUNT_GUEST_CONTACT_SUCCESS,
    payload: payload,
  }
}

/**
 * @returns {object}
 */
export function createAccountGuestContactFailed() {
  return {
    type: CREATE_ACCOUNT_GUEST_CONTACT_FAILED,
  }
}

/**
 * @returns {object}
 */
export function deleteGuest(payload, onSuccess) {
  return {
    payload: payload,
    onSuccess: onSuccess,
    type: DELETE_GUEST_START,
  }
}

/**
 * @returns {object}
 */
export function deleteGuestSuccess() {
  return {
    type: DELETE_GUEST_SUCCESS
  }
}

/**
 * @returns {object}
 */
export function deleteGuestFailed() {
  return {
    type: DELETE_GUEST_FAILED
  }
}

export default {
  createGuestContact,
  createGuestContactSuccess,
  createGuestContactFailed,
  searchGuestContact,
  searchGuestContactFailed,
  searchGuestContactSuccess,
  getGuestContactDetailsById,
  getGuestContactDetailsByIdFailed,
  getGuestContactDetailsByIdSuccess,
  resetGuestContactDetailState,
  addNoteGuestContact,
  addNoteGuestContactFailed,
  addNoteGuestContactSuccess,
  createAccountGuestContact,
  createAccountGuestContactFailed,
  createAccountGuestContactSuccess,
  deleteGuest,
  deleteGuestFailed,
  deleteGuestSuccess
}
